<template>
  <div>
    <div :class="['main-header pl-24 d-flex justify-content-between align-items-center', { 'top-spacing': !shouldHideActionButtons }]">
      <p class="heading fs-16 mb-0">Test Portal</p>
      <VersionControls v-if="canAdminUserAccess && !shouldHideActionButtons" />
    </div>
  </div>
</template>
<script>
import { SYSTEM_ADMIN, STUDY_ADMIN } from "@/constants/authRoles";
import { mapGetters } from "vuex";
import { AclRule } from "vue-acl";
import VersionControls from "@/components/version-management/version-controls";
import localStorageService from "@/services/localStorage";

export default {
  name: "test-portal-banner",
  data() {
    return {
      studyData: {}
    };
  },
  components: {
    VersionControls
  },
  props: {
    shouldHideActionButtons: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["user"]),
    userAccess() {
      return new AclRule(this.user.userRole).generate();
    },
    canAdminUserAccess() {
      return [SYSTEM_ADMIN, STUDY_ADMIN].some(role => this.canRoleAccess(role));
    },
    studyId() {
      return this.$route.params.studyId;
    }
  },
  mounted() {
    /** This was done to mitigate the 403 error for site and study team users,
    when the token has not been refreshed yet.
    Since only admin users can see the action buttons. **/
    if (this.canAdminUserAccess) {
      this.getStudyDetails();
    }
  },
  methods: {
    canRoleAccess(role) {
      this.$acl.change(`${role}`);
      return this.$acl.check("userAccess");
    },
    async getStudyDetails() {
      const storedData = localStorageService.getItem("studyDetailsData") || {};
      const studyDetailsData = storedData[this.studyId];

      if (studyDetailsData) {
        this.studyData = studyDetailsData;
      } else {
        await this.$api.getStudyDataFact(this.studyId).then(response => {
          this.studyData = response.body;
          // save response to localStorage
          const studyDetailsData = localStorageService.getItem("studyDetailsData") || {};
          studyDetailsData[this.studyId] = response.body;
          localStorageService.setItem("studyDetailsData", studyDetailsData);
        });
      }
    }
  }
};
</script>
<style scoped lang="scss">
.main-header {
  height: 48px;
  background-color: #26304f;
  border-bottom: solid 0.3px #4a4a4a;
  position: fixed;
  width: 100%;
  z-index: 900;
}

.top-spacing {
  top: 70px;
}

.heading {
  color: #fff;
}

</style>
